import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getBillingCreditsBalance({ payload: { signal, onSuccess, onError } }) {
  try {
    const { data } = yield call(fetch, { api: api.billing.credits.balance, signal });


    onSuccess && onSuccess(data);
    yield put(actions.getBillingCreditsBalanceDone(data.result));
  } catch (error) {
    onError && onError(error);
    yield handleErrors({
      error,
      putErrorData: actions.getBillingCreditsBalanceFailed,
      endpoint: api.billing.credits.balance.url
    });
  }
}

export const getBillingCreditsBalanceSaga = takeEvery(types.GET_BILLING_CREDITS_BALANCE_REQUEST, getBillingCreditsBalance);